import { ToastProvider } from '@giftgroup/ui';
import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { queryClient } from '../lib/queryClient';

/**
 * Everything the app needs above the router. Tests render through this too, so a
 * provider can never be in one place and not the other.
 *
 * There is exactly one `ToastProvider`: a second one would add a second
 * "Notifications" landmark, which is both an axe failure and a real confusion for
 * anyone navigating by landmark.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      {/* Toasts sit above the bottom nav on phones (doc 06). */}
      <ToastProvider placement="bottom">{children}</ToastProvider>
    </QueryClientProvider>
  );
}
